export default "__VITE_ASSET__g2Hp8izT__"